import React, { ReactNode, useState, useEffect } from "react";
import iconBack from "../../assets/svg/icon-back.svg";
import styled from "styled-components";
import { useLocation, useNavigate } from "react-router-dom";
import { JWT_KEY } from "../../config/constant";
import { postSurvey } from "../../apis/survey";
import { patchUserStatus } from "../../apis/auth";
import { getUserAgent } from "../../utils/utility";
import { getTopic, postNotification } from "../../apis/notification";
import { useModal } from "../../utils/useModal";

interface IAppHeader {
  back?: boolean;
  backFunc?: any;
  skip?: boolean;
  text?: string | ReactNode;
  narrow?: boolean;
  right?: string | ReactNode;
  rightFunc?: any;
}

const AppHeader = ({
  back,
  backFunc,
  skip,
  text,
  right,
  rightFunc,
}: IAppHeader) => {
  const navigate = useNavigate();
  const { pathname } = useLocation();

  const [tailWidth, tailSetWidth] = useState<number>(0);

  const { openModal } = useModal();

  useEffect(() => {
    const element = document.querySelector(
      `${skip ? ".skip" : right ? ".right" : ".tail"}`
    );
    if (element) {
      const rect = element.getBoundingClientRect();
      const width = rect.width;
      tailSetWidth(width);
    }
  }, []);

  const skipFunc = async () => {
    const token = localStorage.getItem(JWT_KEY) as string;

    if (!token) return;

    try {
      const data = [{ surveyType: "SKIP", surveyAnswer: "SKIP" }];

      const { result, message } = await postSurvey(data, token);

      if (!result) return openModal({ type: "guide", message: message });
    } catch (e: any) {
      console.log(e);
      if (e.message === "토큰 재발급 실패")
        openModal({
          type: "login",
          message:
            "연속 14일 간 접속이 없으면\n자동 로그인이 해제돼요. 그전에 또 만나요! 😉",
        });
      else openModal({ type: "guide", message: "오류가 발생했어요!" });
    }

    try {
      const { isSuccess, result, message } = await patchUserStatus(token);

      if (isSuccess && result) {
        sessionStorage.removeItem("age");
        sessionStorage.removeItem("goal");

        if (getUserAgent() === "apple")
          window.webkit?.messageHandlers?.completeSignup.postMessage("");
        else if (getUserAgent() === "android") {
          window.Android.completeSignUp();
        } else {
          const { isSuccess, result, message } = await getTopic();
          if (isSuccess) {
            const { isSuccess, message } = await postNotification({
              pushTopicId: result[0].id,
              scheduleTime: "1200",
            });
            if (!isSuccess) openModal({ type: "guide", message: message });
          } else openModal({ type: "guide", message: message });
        }

        // navigate("/guide");
        navigate("/");
      } else openModal({ type: "guide", message: message });
    } catch (e: any) {
      console.log(e);
      if (e.message === "토큰 재발급 실패")
        openModal({
          type: "login",
          message:
            "연속 14일 간 접속이 없으면\n자동 로그인이 해제돼요. 그전에 또 만나요! 😉",
        });
      else openModal({ type: "guide", message: "오류가 발생했어요!" });
    } finally {
      window.localStorage.removeItem("INACTIVE");
    }
  };

  return (
    <HeaderStyled
      grey={pathname.includes("study") || pathname === "/mypage/edit"}
      tailWidth={tailWidth}
    >
      <div className="lead">
        {back && (
          <img
            className="back"
            src={iconBack}
            alt=""
            onClick={backFunc ? backFunc : () => navigate(-1)}
          />
        )}
      </div>
      {text && <span className="title">{text}</span>}
      {/* <div className="tail"> */}
      {skip && (
        <span className="skip" onClick={skipFunc}>
          건너뛰기
        </span>
      )}
      {right && (
        <span className="right" onClick={rightFunc}>
          {right}
        </span>
      )}

      {!skip && !right && <div className="tail"></div>}
      {/* </div> */}
    </HeaderStyled>
  );
};

export default AppHeader;

const HeaderStyled = styled.header<{
  grey: boolean;
  tailWidth?: number;
}>`
  width: 100vw;
  max-width: ${({ grey }) => (grey ? "100vw" : "42rem")};
  height: 4.6rem;
  padding: 0 2rem;
  display: flex;
  align-items: center;
  justify-content: space-between;

  background-color: ${({ grey }) =>
    grey ? "var(--color-grey)" : "var(--color-white)"};

  .lead {
    min-width: ${({ tailWidth }) =>
      tailWidth !== 0 ? `${tailWidth! / 10}rem` : "2.4rem"};
    display: flex;

    .back {
      width: 2.4rem;
      height: 2.4rem;
    }
  }

  .title {
    font-size: 1.6rem;
    font-weight: 600;
    color: var(--color-grey-900);
    text-align: center;
    flex: 1 1 auto;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    padding: 0 0.4rem;
  }

  .skip {
    font-size: 1.2rem;
    color: var(--color-grey-500);
    text-align: end;
    white-space: nowrap;
    line-height: 4.6rem;
  }

  .right {
    font-size: 1.4rem;
    color: var(--color-grey-500);
    padding: 0 0.2rem;
    text-align: end;
    cursor: pointer;
    display: flex;
    justify-content: flex-end;

    & > .select-all {
      font-size: 1.2rem;
    }
  }

  .tail {
    min-width: 2.4rem;
  }
`;
